// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"331":"287b35e8","431":"287b35e8"}[chunkId] + ".chunk.css";
};